import script from "./CustomerDelivery.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerDelivery.vue?vue&type=script&setup=true&lang=js"

import "./CustomerDelivery.vue?vue&type=style&index=0&id=0e772cc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e772cc8"]])

export default __exports__